import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Box, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { PageWrapper } from '../PageWrapper';

type LinkErrorState = {
    status?: number;
    message?: string;
};

const GenericFail: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const linkError = location.state as LinkErrorState | null;
    const detail = [linkError?.status, linkError?.message]
        .filter((part) => part !== undefined && part !== '')
        .join(' ');

    useEffect(() => {
        const handlePopState = (event: PopStateEvent) => {
            event.preventDefault();
            navigate('/', { replace: true });
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [navigate]);

    const handleButtonClick = () => {
        navigate('/');
    };

    return (
        <PageWrapper>
            <Box
                sx={{
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    backgroundColor: '#CCCCCC',
                    position: 'relative',
                    color: '#00000',
                    gap: '20px',
                    p: '0 10px',
                }}
            >
                <ErrorOutlineIcon sx={{ fontSize: '100px' }} />
                <Typography variant="body1" sx={{ textTransform: 'uppercase' }}>
                    Something went wrong
                </Typography>
                <Typography variant="body2" sx={{ textAlign: 'center' }}>
                    {detail || 'Please scan a valid QR code'}
                </Typography>
                <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={handleButtonClick}
                    sx={{
                        backgroundColor: '#FFFFFF',
                        margin: '20px 0',
                    }}
                >
                    <Typography
                        sx={{ textTransform: 'uppercase', color: '#000' }}
                    >
                        Scan QR Code
                    </Typography>
                </Button>
            </Box>
        </PageWrapper>
    );
};

export default GenericFail;
